const dayjsLocales = {
  'en': () => import('dayjs/locale/en'),
  'es': () => import('dayjs/locale/es'),
  'nl': () => import('dayjs/locale/nl'),
  'de': () => import('dayjs/locale/de'),
}

export default dayjsLocales;